import axios from 'axios';
import get from 'lodash/get';
import { ENV, GIT_VERSION, APP_NAME, WKDA_LOGGER_BASE_URL } from 'config';
import log from '../logger';

const instance = axios.create({
  baseURL: WKDA_LOGGER_BASE_URL,
});

export const ERROR_TYPES = {
  react: 'react-error',
  redux: 'redux-error',
  server: 'server-error',
};

export function logError({ type, level = 'error', error, referrer }) {
  const isLocal = ENV === 'local';

  const body = {
    level,
    referrer,
    appName: APP_NAME,
    appVersion: GIT_VERSION,
    payload: {
      type,
      message: get(error, 'message'),
      stack: get(error, 'stack'),
    },
  };

  if (isLocal) {
    log.error('[DEV] Reporting error', body);

    return Promise.resolve();
  }

  //Fire and (maybe) forget
  return instance
    .post(`/v1/log`, body)
    .then(() => {
      log.info('wkda-logger success');
    })
    .catch(() => {
      log.warn('wkda-logger error');
    });
}
